import { FC } from "react";
import { Spinner } from "../../../components/ui/Spinner";
import { renderStringToHTML } from "../AboutPage";
import aboutPageStore from "../store/aboutPageStore";
import { observer } from "mobx-react-lite";

const PrivacyPolicy: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-2xl font-semibold">Политика конфиденциальности</h2>
      {aboutPageStore.isLoading ? (
        <Spinner></Spinner>
      ) : (
        renderStringToHTML(
          String(aboutPageStore.getSection("privacy"))
        )
      )}
    </div>
  );
};

export default observer(PrivacyPolicy);
